import type { Blog } from '@ztechapps/common.contract'

export const useDocLink = (post: Blog) => {
  return {
    url: `/docs/posts/${post.slug}`,
    href: `/docs/posts/[slug]`,
  }
}
